export async function encodeDataForLinkingSmartAccount(spaceDapp, rootKeySigner, abstractAccountAddress) {
    if (!spaceDapp) {
        throw new Error('spaceDapp is required');
    }
    if (!abstractAccountAddress) {
        throw new Error('abstractAccountAddress is required');
    }
    return spaceDapp.walletLink.encodeLinkCallerToRootKey(rootKeySigner, abstractAccountAddress);
}
